import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "calculation"]

  connect() {
    this.input = this.inputTarget
  }

  changed() {
    for (let c of this.calculationTargets) {
      c.innerText = Number(Math.round(this.input.value * c.dataset.multiplier + "e2") + "e-2")
    }
  }
}
